/**
 * Controller for the projects index page.
 * Initializes DataTable for the projects list.
 */
export default class BackofficeProjectsIndex {
  constructor() {
    this.initDataTable();
  }

  /**
   * Initialize DataTable for the projects table
   */
  initDataTable() {
    const table = $('#projects-datatable');
    if (table.length === 0) {
      return;
    }

    this.dataTable = table.DataTable({
      paging: true,
      ordering: true,
      searching: true,
      info: true,
      lengthChange: false,
      pageLength: 25,
      language: {
        url: '/data-tables/locales/' + I18n.locale + '.json'
      },
      columnDefs: [
        {
          targets: [2, 3, 4],
          className: 'text-center'
        },
        {
          targets: 4,
          orderable: false
        }
      ],
      order: [[0, 'asc']] // Order by name ascending by default
    });
  }

  /**
   * Cleanup when leaving the page
   */
  onDestroy() {
    if (this.dataTable) {
      this.dataTable.destroy();
      this.dataTable = null;
    }
  }
}
